import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ShipmentSpecialFreightMainInfoFacade } from './shipment-special-freight-main-info.facade';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ShipmentSpecialFreightItemFacade } from '../shipment-special-freight-item.facade';
import { SpecialFreightIdView } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentSpecialFreightMainInfoGuard {
  constructor(
    private shipmentSpecialFreightMainInfoFacade: ShipmentSpecialFreightMainInfoFacade,
    private shipmentSpecialFreightItemFacade: ShipmentSpecialFreightItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentSpecialFreightItemFacade.specialFreightIdentifier$.pipe(
      switchMap((identifier: SpecialFreightIdView) => {
        loadStoreState(this.shipmentSpecialFreightMainInfoFacade, identifier);

        return of(true);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentSpecialFreightMainInfoFacade);
  }
}
